import React from "react";
import { useNavigate } from "react-router";
import { Container } from "reactstrap";
import PricingBg from "src/assets/images/unit-5-pricing-bg.jpg";
import Typography from "src/components/Typography";
import PriceCard from "./PriceCard";
import classes from "./styles.module.scss";

const Pricing = () => {
  const navigate = useNavigate();

  return (
    <div
      id="unit5-pricing"
      className={classes.wrapper}
      style={{
        backgroundImage: `url(${PricingBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container className={classes.container}>
        <Typography className={classes.title} fontWeight="bold">
          Pricing
        </Typography>
        <Typography className={classes.description}>
          Unit 5 proudly serves customers across the US with superior <br />
          customer service at reasonable prices
        </Typography>
        <div className={classes.priceCards}>
          <PriceCard
            active
            title="Impact Testing"
            price={500}
            description="Shipping included in the price above"
            buttonText="Order an Impact Test"
            handleAction={() => navigate("/order/create")}
          />
        </div>
      </Container>
    </div>
  );
};

export default Pricing;
